// Central registry of Selected Work projects.
// Add new projects here — the index page and detail routes will pick
// them up automatically.
//
// Each project stores an `imageBase` (path without extension) which
// <PictureAsset /> expands into a responsive WebP + JPEG bundle at
// 1600w and 3200w. `image` is retained as a plain URL to the JPEG
// fallback for legacy consumers that render a single <img>.

const BASES = {
  warmAfter:    "/assets/projects/in-the-warm-after/thumbnail",
  tieAndUntie:  "/assets/projects/tie-and-untie/thumbnail",
  windowsToArt: "/assets/projects/windows-to-art/thumbnail",
  chickooMane:  "/assets/projects/chickoo-mane/thumbnail",
  gurukul:      "/assets/projects/gurukul/thumbnail",
  ripples:      "/assets/projects/ripples/thumbnail",
};
const asset = (base) => ({ imageBase: base, image: `${base}-3200.jpg` });

export const PROJECTS = [
  {
    slug: "in-the-warm-after",
    name: "In The Warm After;",
    type: "Residential interior renovation",
    location: "Binnypet, Bengaluru",
    area: "1800 sq. ft.",
    photography: "Phosart Studio",
    descriptor:
      "A home made to embody a lingering emotion — the gentle resonance that remains after an experience has settled, like light that stays in a room just after sunset.",
    ...asset(BASES.warmAfter),
    tall: true,
  },
  {
    slug: "tie-and-untie",
    name: "Tie and Untie",
    type: "Residential interiors",
    location: "Yemlur, Bengaluru",
    area: "1700 sq. ft.",
    photography: "Nayan Soni",
    descriptor:
      "The home\u2019s ethos can be understood through the image of a humble thread — moving across fabric, leaving linear and winding trails, and quietly stitching a sense of cohesion.",
    ...asset(BASES.tieAndUntie),
    tall: false,
  },
  {
    slug: "windows-to-art",
    name: "Windows to Art",
    type: "Residential interior renovation & styling",
    location: "Basavanagudi, Bengaluru",
    area: "350 sq. ft.",
    photography: "Streetscape Photography",
    descriptor:
      "An interior inspired by Mysore\u2019s painted traditions, where colour, handcrafted motifs, and touches of gold bring cultural memory into a quiet everyday sanctuary.",
    ...asset(BASES.windowsToArt),
    tall: false,
  },
  {
    slug: "chickoo-mane",
    name: "Chikoo Mane",
    type: "Residential architecture",
    location: "JP Nagar, Bengaluru",
    area: "3500 sq. ft.",
    photography: "Shamanth Patil",
    descriptor:
      "Set on the fringes of a vibrant forest, this home brings together tradition, contemporary living, and the calm of a green oasis.",
    ...asset(BASES.chickooMane),
    tall: true,
  },
  {
    slug: "gurukul",
    name: "The Thread of Tradition",
    credibility: "Sri Kumaran Children\u2019s Home Educational Council",
    type: "Institutional interior renovation",
    location: "Tata Silk Farm, Bengaluru",
    area: "500 sq. ft.",
    photography: "Nayan Soni",
    descriptor:
      "Museum-like displays celebrate the institution\u2019s history, milestones, and achievements, bringing together functionality and storytelling to honour both past and future.",
    ...asset(BASES.gurukul),
    tall: false,
  },
  {
    slug: "ripples",
    name: "Ripples",
    type: "Residential interiors",
    location: "Jayanagar, Bengaluru",
    area: "2100 sq. ft.",
    photography: "Nayan Soni",
    descriptor:
      "A forthcoming residence where colour, memory, and atmosphere move quietly through the rooms.",
    ...asset(BASES.ripples),
    private: true,
    embargoNote: "This project is currently reserved for publication.",
    tall: false,
  },
];

export const findProject = (slug) =>
  PROJECTS.find((p) => p.slug === slug) || null;

// Editorial soft gate for the Ripples embargo. The portfolio is not
// a security boundary — anyone given the password can view the
// hosted gallery. The destination URL is base64-encoded so it does
// not appear in the page source as a readable string; it's only
// decoded after the password matches.
export const RIPPLES_PASSWORD = "therippleeffect";
// b64( https://drive.google.com/drive/folders/1tK_PpttOcvj3Q4sW6g3xeghdtQ7_xiB7 )
export const RIPPLES_DESTINATION_ENC =
  "aHR0cHM6Ly9kcml2ZS5nb29nbGUuY29tL2RyaXZlL2ZvbGRlcnMvMXRLX1BwdHRPY3ZqM1E0c1c2ZzN4ZWdoZHRRN194aUI3";
